<ng-container *ngIf="fabricForgotPasswordComponent; else standardForgotPasswordComponent">
	<ng-container *ngIf="translations$ | async as translations">
		<account-forgot_password_v2
			[translations]="translations"
			[parentHandlesConfirmation]="true"
			(submittedSuccessfully)="showSuccessAlert()"
		></account-forgot_password_v2>
	</ng-container>
</ng-container>
<ng-template #standardForgotPasswordComponent>
	<obg-m-forgot-password-email-container
		(isBusy)="toggleLoading($event)"
		(success)="showSuccessAlert()"
	></obg-m-forgot-password-email-container>
</ng-template>
<ng-container *ngIf="!hideFooter">
	<obg-compact-footer></obg-compact-footer>
</ng-container>
